module.exports = __webpack_public_path__ + "fonts/Montserrat-Bold.88932da.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/components/posters/blossom-l/fonts/Montserrat-Bold.ttf
// module id = 474
// module chunks = 0